export interface VulnerableProject {
  projectName: string;
  high: number;
  medium: number;
  low: number;
}
